let unsubscribe;

const kbkCharacters =[
    {
        image:'chicken',
        name:'Charlie Chicken',
        path:'/assets/img/ChickenRacer/ChickenRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'monkey',
        name:'Mortimer Monkey',
        path:'/assets/img/MonkeyRacer/MonkeyRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'gator',
        name:'Gordon Gator',
        path:'/assets/img/GatorRacer/GatorRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'rhino',
        name:'Ringo Rhino',
        path:'/assets/img/RhinoRacer/RhinoRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'lion',
        name:'Leroy Lion',
        path:'/assets/img/LionRacer/LionRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'elephant',
        name:'Elvin Elephant',
        path:'/assets/img/ElephantRacer/ElephantRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'giraffe',
        name:'Gerald Giraffe',
        path:'/assets/img/GiraffeRacer/GiraffeRacer (1).png',
        theme:'default',
        selected:false
    },
    {
        image:'trex',
        name:'Theodore Rex',
        path:'/assets/img/TrexRacer/RexRacer (1).png',
        theme:'default',
        selected:false
    }
];

const otherCharacters =[
    {
        image:'chicken',
        name:'',
        path:'/assets/img/A/A1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'monkey',
        name:'',
        path:'/assets/img/F/F1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'gator',
        name:'',
        path:'/assets/img/C/C1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'rhino',
        name:'',
        path:'/assets/img/G/G1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'lion',
        name:'',
        path:'/assets/img/E/E1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'elephant',
        name:'',
        path:'/assets/img/B/B1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'giraffe',
        name:'',
        path:'/assets/img/D/D1-01.png',
        theme:'default',
        selected:false
    },
    {
        image:'trex',
        name:'',
        path:'/assets/img/H/H1-01.png',
        theme:'default',
        selected:false
    }
];

class CharacterController{
    /*@ngInject*/
    constructor(SocketService,$state,EventService, SessionService, UserService){
        this.socket = SocketService;
        this.$state = $state;
        this.event = EventService;
        this.session = SessionService;
        this.user = UserService.getUser();
    }
    $onInit(){
        this.socket.send('navigate',{page:'characters'});
        if(typeof this.user.appId === 'undefined' || this.user.appId.toLowerCase()==='kbk'){
            this.characters = kbkCharacters;
        }else{
            this.characters = otherCharacters;
        }
        
        unsubscribe = this.event.subscribe('gameInfo',data=>{
            this.session.set('gameData',data);
            this.$state.go('play');
        });
    }

    $onDestroy(){
        unsubscribe();
    }
    highlight(p,red){
        if(p.selected){
            return false;
        }
        p.theme = red ? 'dark-red':'default';
    }
    select(character){
        this.characters.forEach(c=>{
            c.selected=false;
            c.theme='default';
        });
        character.selected=true;
        character.theme = 'dark-green';
        this.socket.send('setAvatar',{avatar:character.image});
    }
    play(){
        this.socket.send('joinGame');
        // this.$state.go('play');
    }
    nextDisabled(){
        return this.characters.every(character=>character.selected===false);
    }

}

export default CharacterController;


// WEBPACK FOOTER //
// ./public/app/characters/character.controller.js